module.exports = __webpack_public_path__ + "static/Boogy_Brut_WEB-Light-4bdaf40eeca7cfa49426fa82c6278053.woff2";